// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { ArticleAttributeVO, ArticleInfoVO } from '@project/model/vo/project.vo';
import { MetaElementVO } from '@shared/vo/meta-element.vo';
import { ArticleContainer } from '../model3d/article-container';
import { ContainerService } from '../model3d/container.service';
import { ArticleUsageUtils } from '@article/util/article-usage-utils';
import { ArticleService } from '@article/service/article.service';
import { ArticleContainerPropertyDef } from '@article/constants/article-container-property-def';

@Injectable({
  providedIn: 'root'
})
export class ArticleContainerService {

  constructor(
    private containerService: ContainerService,
    private articleService: ArticleService
  ) {}

  public getBaseRangeOnLineContainer(articleContainer: ArticleContainer): ArticleContainer {
    if (!articleContainer) {
      return null;
    }
    if (this.articleService.isRangeOnLineArticle(articleContainer.article)) {
      return articleContainer;
    }
    const parentUsageId: string = ArticleUsageUtils.getFirstBackwardConnectedArticleUsageId(articleContainer.articleUsage);
    return this.getBaseRangeOnLineContainer(this.containerService.findArticleContainerInGlobal(parentUsageId));
  }

  /**
   * Create ArticleInfo instance that contains basic information about dynamic article.
   * This info used to handle (for example load) projects with dynamic articles.
   *
   * @param container
   * @param originalMetaElements
   * @return
   *
   */
  public createDynamicArticleInfo(
    container: ArticleContainer,
    originalMetaElements: MetaElementVO[]
  ): ArticleInfoVO {
    const articleInfo: ArticleInfoVO = this.articleService.createArticleInfo(container.articleGUID, container.article, originalMetaElements);
    if (container.properties.containsKey(ArticleContainerPropertyDef.STRETCH_LENGTH)) {
      const stretchAttribute: ArticleAttributeVO = new ArticleAttributeVO();
      stretchAttribute.name = ArticleContainerPropertyDef.STRETCH_LENGTH;
      stretchAttribute.values = [container.properties.getValue(ArticleContainerPropertyDef.STRETCH_LENGTH)];
      articleInfo.attributes.push(stretchAttribute);
    }
    if (container.properties.containsKey(ArticleContainerPropertyDef.TEXT_ANGLE)) {
      const textAngleAttribute: ArticleAttributeVO = new ArticleAttributeVO();
      textAngleAttribute.name = ArticleContainerPropertyDef.TEXT_ANGLE;
      textAngleAttribute.values = [container.properties.getValue(ArticleContainerPropertyDef.TEXT_ANGLE)];
      articleInfo.attributes.push(textAngleAttribute);
    }
    if (container.properties.containsKey(ArticleContainerPropertyDef.ARTICLES_GUIDS_BETWEEN_ADAPTERS)) {
      const articleGUID: ArticleAttributeVO = new ArticleAttributeVO();
      articleGUID.name = ArticleContainerPropertyDef.ARTICLES_GUIDS_BETWEEN_ADAPTERS;
      articleGUID.values = container.properties.getValue(ArticleContainerPropertyDef.ARTICLES_GUIDS_BETWEEN_ADAPTERS);
      articleInfo.attributes.push(articleGUID);
    }
    return articleInfo;
  }
}
